const ffi = require("ffi");
const path = require('path')
export default class PrintCode {
    constructor(iMode = 1) {
        this.iModeType = {
            VoteType_Choice: 10,//选择题
            // VoteType_TrueFalse: 5,//判断题
            VoteType_Signin: 1,//签到
        }
        this.iBaseID = null //int 事件发生的基站ID
        this.iMode = iMode //int 基站连接模式1 使用USB方式连接基站2 使用TCPIP方式连接基站3 蓝牙模式(移动设备) 4 com口连接(移动设备) 5 android usb连接(移动设备)
        this.sInfo = -1 //Char “1”基站连接成功 “2”基站连接失败或已断开
        this.ownErrorCallback = null //设置失败操作的回调
        this.ownKeyEventCallBack = null //设置键盘事件的回调
        this.User32 = ffi.Library(
            path.resolve("resources/SDK4WindowsV4.4.5/SunVoteSDK_x64.dll"),
            {
                License: ["int", ["int", "string"]], //获得授权 获取厂家授权，以便能够启动基站进行连接、投票或读写参数
                Connect: ["int", ["int", "string"]], //连接基站
                Disconnect: ['int', ['int']], //断开基站连接
                SetConnectEventCallBack: ["void", ["pointer"]], //连接事件的回调
                SetKeyEventCallBack: ["void", ["pointer"]], //键盘事件的回调
                SetVoteEventCallBack: ["void", ["pointer"]], //投票事件回调函数
                VoteStart2: ["int", ["int", "int", "string"]],//对单个基站发起投票
                VoteStop2: ['int', ['int']],//停止投票
                SetLogOn: ['int', ['int']]//启动或停止记录日志
            }
        );
        const SetLogOn = this.User32.SetLogOn(0)
        console.log('停止日志结果', SetLogOn)
        //获取授权
        this.License = this.User32.License(1, "SUNARS2013")
        
        console.log(`授权返回值:${this.License}`)
        // 连接事件回调函数
        this.User32.SetConnectEventCallBack(ffi.Callback(
            "void",
            ["int", "int", "string"],
            (iBaseID, iMode, sInfo) => {
                console.log(
                    `连接事件回调函数: iBaseID=${iBaseID}, iMode=${iMode}, sInfo=${sInfo}`
                );
                // sInfo
                // “1”基站连接成功
                // “2”基站连接失败或已断开
                this.iBaseID = iBaseID
                this.sInfo = sInfo
                if (this.ownConnectEventCallBack) {
                    this.ownConnectEventCallBack(iBaseID, iMode, sInfo)
                }
            }
        ))
        //设置键盘事件回调函数
        this.User32.SetKeyEventCallBack(ffi.Callback(
            "void",
            ["int", "int", "string", "int", "float", "string"],
            (iBaseID, iKeyID, sKeySN, iMode, Time, sInfo) => {
                // 在这里编写回调函数的具体实现
                // console.log(iBaseID, iKeyID, sKeySN, iMode, Time, sInfo);
                if (this.ownKeyEventCallBack) {
                    this.ownKeyEventCallBack(iBaseID, iKeyID, sKeySN, iMode, Time, sInfo)
                }
            }
        ))
        // 设置投票回调函数
        this.User32.SetVoteEventCallBack(ffi.Callback(
            "void",
            ["int", "int", "string"],
            (iBaseID, iMode, sInfo) => {
                // 在这里编写回调函数的具体实现
                console.log(
                    `投票回调函数: iBaseID=${iBaseID}, iMode=${iMode}, sInfo=${sInfo}`
                );
            }
        ))
    }
    //连接事件回调函数
    setOwnConnectEventCallBack(callback) {
        this.ownConnectEventCallBack = callback
    }
    //键盘事件回调函数
    setOwnKeyEventCallBack(callback) {
        this.ownKeyEventCallBack = callback
    }
    //连接基站
    Connect() {
        this.User32.Connect(this.iMode, "");
    }
    //开始或继续投票
    VoteStart2(iMode, sSetting) {
        if (this.sInfo != 1) {
            if (this.ownErrorCallback) return this.ownErrorCallback({ message: '基站未连接或被中断' })
        }
        if (typeof iMode !== 'string' || !iMode) {
            throw Error('投票投票类型错误')
        }
        if (this.iBaseID && this.sInfo == 1) {
            const iModeValue = this.iModeType[iMode]
            console.log(`开始投票,${this.iBaseID}, ${iModeValue}, ${sSetting}`)
            const VoteStart2 = this.User32.VoteStart2(this.iBaseID, iModeValue, sSetting);
            console.log(`VoteStart2返回值${VoteStart2}`)
        } else {
            if (this.ownErrorCallback) this.ownErrorCallback({ message: '基站未连接或被中断' })
        }
    }
    //停止投票
    VoteStop2() {
        this.User32.VoteStop2(this.iBaseID)
    }
    //断开基站连接
    Disconnect() {
        console.log("开始执行断开基站连接")
        console.log(this.iBaseID, this.sInfo)
        const Disconnect = this.User32.Disconnect(this.iBaseID)
        console.log(`断开基站连接: ${Disconnect}`)
    }
    //错误操作的回调
    setOwnErrorCallback(callback) {
        this.ownErrorCallback = callback
    }
}